<template>
  <div class="collapse">
    <slot></slot>
  </div>
</template>

<script>
import { defineComponent } from "@vue/composition-api";
import Vue from "vue";

export default defineComponent({
  setup() {},
  data() {
    return { eventBus: new Vue() };
  },
  props: {
    single: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Array,
    },
  },
  provide() {
    return { eventBus: this.eventBus };
  },
  mounted() {
    this.eventBus.$emit("update:selected", this.selected);
    this.eventBus.$on("update:addSelected", (name) => {
      let selectedCopy = JSON.parse(JSON.stringify(this.selected));
      if (this.single) {
        selectedCopy = [name];
      } else {
        selectedCopy.push(name);
      }
      this.$emit("update:selected", selectedCopy);
      this.eventBus.$emit("update:selected", selectedCopy);
    });
    this.eventBus.$on("update:removeSelected", (name) => {
      let selectedCopy = JSON.parse(JSON.stringify(this.selected));
      const index = selectedCopy.indexOf(name);
      selectedCopy.splice(index, 1);
      this.$emit("update:selected", selectedCopy);
      this.eventBus.$emit("update:selected", thiselectedCopy);
    });
  },
});
</script>

<style lang="scss" scoped>
.collapse {
  $grey: #ddd;
  $border-radius: 4px;
  border: 1px solid $grey;
  border-radius: $border-radius;
}
</style>
